import React, { useEffect, useState } from "react";
import Layout from "src/components/app/layout/Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const SuccessScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    success,
    successMessageTitle,
    successMessageDescription,
    redirectUrl,
  } = location.state || {};
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      navigate(redirectUrl);
    }
  }, [countdown]);

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div className="relative w-full h-full p-4 bg-white flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-4">
          <CheckCircle className="w-16 h-16 text-green-500" />
        </div>
        <div className="flex flex-col items-center justify-center gap-1 text-center">
          <h1 className="text-xl font-bold">{successMessageTitle}</h1>
          <p className="text-sm text-gray-500">
            {successMessageDescription}. You will be redirected to the home
            screen in {countdown} seconds.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default SuccessScreen;
